import type { AttributeInGroupResponse, AttributeResponse } from '@/entities/attributes';
import type { PredicateValue } from '@/entities/predicate';

/** Данные атрибута, которых хватает строке состава: справочник атрибутов за ней не стоит */
export type GroupAttributeValue = {
  code: string;
  name: string;
  description: string;
};

/** Оставляет только то, что показывает строка состава: источники разные — сама группа и окно добавления, хранимый вид один */
export const toGroupAttributeValue = (
  attribute: AttributeInGroupResponse | AttributeResponse,
): GroupAttributeValue => ({
  code: attribute.code,
  name: attribute.name,
  description: attribute.description,
});

export type AttributeGroupFormValues = {
  name: string;
  code: string;
  description: string;
  attributes: GroupAttributeValue[];
  predicate: PredicateValue;
};
